export enum GoogleApiBaseUrls {
  PLACES = 'https://places.googleapis.com/v1',
  ADDRESS_VALIDATION = 'https://addressvalidation.googleapis.com/v1',
}
